import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { replace } from 'connected-react-router'
import * as paths from '../MainRoutes/constants'
import { bindPromiseCreators } from '../../utils/routines'

import { createLoginPromise } from './routines'
import '../../utils/validations/extendYup'

// redux
export const mapDispatchToProps = dispatch => ({
  ...bindPromiseCreators({
    login: createLoginPromise
  }, dispatch),
  ...bindActionCreators({ redirectTo: replace }, dispatch)
})
const connector = connect(null, mapDispatchToProps)

// formik
export const mapPropsToValues = () => ({ username: '', password: '' })
export const validationSchema = yup.object().shape({
  username: yup.string().email().required(),
  password: yup.string().required()
})
export async function handleSubmit(values, { props, setStatus, setSubmitting }) {
  try {
    await props.login(values)
    // dont need setStatus with redirect
    // setStatus({ success: result.response })
    return props.redirectTo(paths.APPLICATIONS_PATH)
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}
const formik = withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})

// enhancer
const enhancer = compose(
  connector,
  formik
)

export default enhancer
